export const IMMAPER_TAR_FORM_ADD_CONNECTION = 'IMMAPER_TAR_FORM_ADD_CONNECTION'
export const IMMAPER_TAR_FORM_DELETE_CONNECTION = 'IMMAPER_TAR_FORM_DELETE_CONNECTION'
export const IMMAPER_TAR_FORM_CHANGE_ITINERARY = 'IMMAPER_TAR_FORM_CHANGE_ITINERARY'
export const IMMAPER_TAR_FORM_ONCHANGE = 'IMMAPER_TAR_FORM_ONCHANGE'
export const IMMAPER_TAR_FORM_RESET = 'IMMAPER_TAR_FORM_RESET'
export const IMMAPER_TAR_FORM_ADD_NON_WORKING_DAYS = 'IMMAPER_TAR_FORM_ADD_NON_WORKING_DAYS'
export const IMMAPER_TAR_FORM_DELETE_NON_WORKING_DAYS = 'IMMAPER_TAR_FORM_DELETE_NON_WORKING_DAYS'
export const IMMAPER_TAR_FORM_CHANGE_NON_WORKING_DAYS = 'IMMAPER_TAR_FORM_CHANGE_NON_WORKING_DAYS'